// extracted by mini-css-extract-plugin
export default {"agreement":"txfe57VJ"};